import React from 'react'
import classNames from 'classnames'
import { quarters } from '../utils'
import { useReportsContext } from '../ReportsContext'

const FiscalQuarterSelect = () => {
  const {
    quarterInputValue,
    selectQuarter,
    getQuarterError,
    handleQuarterBlur,
  } = useReportsContext()
  const hasError = getQuarterError()

  return (
    <div
      className={classNames('usa-form-group maxw-mobile margin-top-4', {
        'usa-form-group--error': hasError,
      })}
    >
      <label className="usa-label text-bold margin-top-4" htmlFor="quarter">
        Fiscal Quarter*
        {hasError && (
          <div className="usa-error-message" id="quarter-error-alert">
            A fiscal quarter is required
          </div>
        )}
        <select
          className={classNames('usa-select maxw-mobile', {
            'usa-input--error': hasError,
          })}
          name="quarter"
          id="quarter"
          onChange={selectQuarter}
          onBlur={handleQuarterBlur}
          value={quarterInputValue}
          aria-describedby="quarter-error-alert"
        >
          <option value="" disabled hidden>
            - Select Quarter -
          </option>
          {Object.entries(quarters).map(([quarter, quarterDescription]) => (
            <option value={quarter} key={quarter}>
              {quarterDescription}
            </option>
          ))}
        </select>
      </label>
    </div>
  )
}

export default FiscalQuarterSelect
